import { useMutation, useQueryClient } from '@tanstack/react-query';
import { channelsApi } from '../services';
import type { CreateChannelRequest } from '@troia-v3/types';

/**
 * Hook to create a new channel
 *
 * @example
 * const createChannel = useCreateChannel();
 * createChannel.mutate(channelData, {
 *   onSuccess: () => console.log('Channel created!'),
 * });
 */
export const useCreateChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateChannelRequest) => channelsApi.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['channels'] });
    },
  });
};
